<template>
  <div class="page-detail">
    <banner />
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/company/home/${id}`">{{
          model.Name
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>产品服务</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content" v-loading="loading" v-if="productList.length > 0">
        <product-card
          v-for="item in productList"
          :data="item"
          :key="item.Id"
        ></product-card>
      </div>
      <div v-else class="g-nodata"></div>
      <el-pagination
        v-if="total > pageSize"
        class="g-pagination"
        background
        layout="prev, pager, next"
        :current-page="pageIndex"
        :page-size="pageSize"
        :total="total"
        @current-change="handleIndexChange"
      >
        ></el-pagination
      >
    </div>
  </div>
</template>

<script>
import { getDetail, getData } from "api/app";
import Banner from "./components/Banner.vue";
import ProductCard from "./components/ProductCard.vue";
export default {
  data() {
    return {
      model: {
        title: "",
        time: "",
        source: "",
        content: "",
        id: "",
        prev: null,
        next: null
      },
      id: "",
      productList: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      loading: false
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.init();
  },
  components: {
    [Banner.name]: Banner,
    [ProductCard.name]: ProductCard
  },
  methods: {
    handleIndexChange(index) {
      this.pageIndex = index;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      getDetail({ name: "Enterprise", id: this.id }).then(res => {
        this.model = res || {};
      });
      var params = [
        { Key: "Enterprise", Value: this.id, CompareType: "EqualTo" }
      ];
      var queryParams = {
        name: "ProductService",
        index: this.pageIndex,
        size: this.pageSize ?? 10,
        params
      };
      getData(queryParams).then(res => {
        this.productList = res.Data || [];
        this.total = res.TotalCount;
        console.log(this.total);
        this.loading = false;
      });
    },
    init() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-detail {
  background: #f6f6f9;
  padding-bottom: 40px;
  .content {
    display: flex;
    flex-wrap: wrap;
  }
  .g-pagination {
    margin-top: 12px;
  }
}
</style>
